'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar, Button } from '@common/components';
import { SvgChevronright } from '@common/icon';
import { useCallback, useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';
import { useStatusBarColor } from '@/hooks/useStatusBarColor';
import { useAuthStore } from '@/stores/AuthStore';
import { STATUS_COLOR } from '@/stores/DeviceStore';
import { HeaderActionPopover } from './HeaderActionPopover';
import { ProfilePopoverContent } from './ProfilePopoverContent';
export const ProfileSection = t0 => {
  const $ = _c(17);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "mobile" : t1;
  const isLogin = useAuthStore(_temp);
  const myInfo = useAuthStore(_temp2);
  const [profileOpen, setProfileOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: STATUS_COLOR.DEFAULT
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useStatusBarColor(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = open => {
      setProfileOpen(open);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleProfileChange = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setProfileOpen(false);
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const closeProfile = t4;
  if (!isLogin || !myInfo) {
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <CustomLink href={ROUTES.LOGIN.pathname} className="group flex items-center gap-12 px-32 py-26 transition-colors duration-200 ease-out active:bg-Gray-100 motion-reduce:transition-none"><Avatar size={48} alt={"\uD504\uB85C\uD544"} /><span className="flex grow items-center gap-8 font-600 text-Gray-black typo-body2">로그인 후 이용할 수 있어요</span><SvgChevronright aria-hidden="true" className="size-16 text-Gray-black" /></CustomLink>;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    return t5;
  }
  let t5;
  if ($[4] !== myInfo.profileImage) {
    t5 = <Avatar size={48} src={myInfo.profileImage} alt={"\uD504\uB85C\uD544"} />;
    $[4] = myInfo.profileImage;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = myInfo.nickName || "\uD68C\uC6D0";
  let t7;
  if ($[6] !== t6) {
    t7 = <span className="font-600 text-Gray-900 typo-body2">{t6}</span>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t7) {
    t8 = <div className="flex items-center gap-8">{t5}{t7}</div>;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== profileOpen || $[12] !== variant) {
    t9 = variant === "desktop" ? <HeaderActionPopover open={profileOpen} onOpenChange={handleProfileChange} contentClassName="w-[320px]" triggerClassName="w-auto" placement="bottom-start" floatingPadding={12} trigger={<Button type="button" theme="sub-line" className="bg-Gray-white" dimensions="H32">정보 수정</Button>}><ProfilePopoverContent onClose={closeProfile} /></HeaderActionPopover> : <Button asChild={true} theme="sub-line" className="bg-Gray-white" dimensions="H32"><CustomLink href={ROUTES.MY_EDIT.pathname}>정보 수정</CustomLink></Button>;
    $[11] = profileOpen;
    $[12] = variant;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <div className="flex items-center justify-between px-32 py-26">{t8}{t9}</div>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(state_0) {
  return state_0.myInfo;
}